import type { H3Event } from 'h3'

/**
 * Pages gardées une heure en cache par le serveur (routes `swr` de nuxt.config.ts).
 */
export class CachedPageUtils {
  /**
   * Trace un appel API raté pendant le rendu d'une page et empêche le serveur de garder cette page en cache.
   * @param {string} apiPath - Route d'API appelée.
   * @param {unknown} error - Erreur reçue.
   * @param {H3Event | undefined} requestEvent - Requête en cours côté serveur, absente dans le navigateur.
   * @returns {void}
   */
  static reportFailedApiCall(
    apiPath: string,
    error: unknown,
    requestEvent: H3Event | undefined,
  ): void {
    console.error(
      `[CachedPageUtils] Appel ${apiPath} échoué :`,
      error instanceof Error ? error.message : error,
    )

    // Le cache du serveur refuse une réponse dont l'en-tête `last-modified` vaut « undefined » : la dernière bonne version de la page reste servie.
    requestEvent?.node.res.setHeader('last-modified', 'undefined')
  }
}
